// The sidebar / header logo, resolved against the app's BASE.
//
// ⛔ THIS WAS A BARE ABSOLUTE PATH ("/logos/logo_jarvis_dark.svg") AND THAT
// BROKE THE LOGO ON THE TAILORMIND EREZ BOX (22 Aug 2026).
//
// This app is served from two places with two different bases. On Cloudflare
// Pages it is the site root, so "/logos/..." resolves. On the Tailormind Erez
// box it is the App screen INSIDE the console, served by Vite with
// `base: "/dash/"` — so a public/ asset lives at "/dash/logos/...", and a
// leading-slash path walks straight past it to the console's own root. The
// file was never missing: measured on that box, "/logos/logo_jarvis_dark.svg"
// returned 404 and "/dash/logos/logo_jarvis_dark.svg" returned 200 image/svg+xml
// from the very same file on disk.
//
// `import.meta.env.BASE_URL` is Vite's own answer to this and always carries a
// trailing slash, so it yields "/logos/..." on Pages and "/dash/logos/..." on
// the box from one line. Never hardcode a leading slash for a public/ asset
// here; it will look correct everywhere except the surface Erez actually
// watches, which is the worst place for it to be wrong.
export const myjarvisLogoUrl = `${import.meta.env.BASE_URL}logos/logo_jarvis_dark.svg`;
